function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M17.0036 20.0804L13.1434 17.8689L0 10.3389V29.8223L35.0493 49.9026V30.4192L28.0396 26.4032L26.0266 25.2498L21.0295 22.387L17.0036 20.0804Z",
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M17.0033 0L0.520508 9.44344L12.8826 16.5259L17.0033 18.8866V0Z",
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M26.0268 24.0559V14.3141L34.5287 9.44344L18.0459 0V19.4834L21.2382 21.3125L26.0268 24.0559Z",
  fill: "white"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M35.0498 29.2254V10.3389L27.0688 14.9111V24.6529L28.6652 25.5673L35.0498 29.2254Z",
  fill: "white"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M61.9796 14.3135C62.9735 14.3135 64.3556 14.4097 65.5196 15.1797C66.8775 16.07 67.5322 17.61 67.5322 19.0779C67.5322 20.016 67.2894 21.46 65.956 22.5907C64.6709 23.6735 63.192 23.8419 62.0035 23.8419H60.8884V30.3625H58.415V14.3135H61.9796ZM60.8884 21.58H62.0035C64.1374 21.58 65.1558 20.5454 65.1558 19.0538C65.1558 18.1635 64.7921 16.5754 61.9796 16.5754H60.8884V21.58Z",
  fill: "white"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M87.2229 14.3135V28.0525H91.9753V30.3625H84.7495V14.3135H87.2229Z",
  fill: "white"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M118.575 26.4884H111.665L109.894 30.3622H107.227L115.277 13.375L122.939 30.3622H120.272L118.575 26.4884ZM117.581 24.1784L115.18 18.7406L112.683 24.1784H117.581Z",
  fill: "white"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M143.358 16.6235V30.3625H140.885V16.6235H137.175V14.3135H147.068V16.6235H143.358Z",
  fill: "white"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M173.014 16.6232H166.564V20.6897H172.82V22.9997H166.564V28.0525H173.014V30.3625H164.091V14.3135H173.014V16.6232Z",
  fill: "white"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M198.596 26.4884H191.686L189.915 30.3622H187.248L195.298 13.375L202.96 30.3622H200.293L198.596 26.4884ZM197.602 24.1784L195.201 18.7406L192.703 24.1784H197.602Z",
  fill: "white"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M218.625 14.3135V23.9863C218.625 24.8525 218.649 25.9113 219.134 26.7532C219.619 27.5713 220.71 28.4132 222.141 28.4132C223.572 28.4132 224.663 27.571 225.148 26.7532C225.633 25.911 225.657 24.8522 225.657 23.9863V14.3135H228.13V24.6357C228.13 25.911 227.864 27.451 226.627 28.7982C225.778 29.7125 224.348 30.675 222.141 30.675C219.935 30.675 218.504 29.7125 217.656 28.7982C216.419 27.4507 216.152 25.911 216.152 24.6357V14.3135H218.625Z",
  fill: "white"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M179.387 37.7041V40.6179C179.704 40.1891 180.181 40.0491 180.612 40.0491C181.15 40.0491 181.635 40.2504 181.979 40.5741C182.358 40.9329 182.597 41.4666 182.597 42.1144C182.597 42.7182 182.385 43.2782 181.979 43.6807C181.635 44.0307 181.212 44.2144 180.63 44.2144C179.934 44.2144 179.581 43.8907 179.387 43.6104V44.0832H178.117V37.7044H179.387V37.7041ZM179.589 41.4232C179.439 41.5807 179.307 41.8079 179.307 42.1407C179.307 42.4641 179.448 42.7007 179.598 42.8404C179.801 43.0329 180.083 43.1294 180.321 43.1294C180.542 43.1294 180.789 43.0419 180.983 42.8582C181.168 42.6829 181.291 42.4294 181.291 42.1407C181.291 41.8254 181.168 41.5719 180.983 41.3966C180.78 41.2044 180.559 41.1341 180.304 41.1341C180.03 41.1341 179.792 41.2129 179.589 41.4232Z",
  fill: "white"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M187.26 43.5844L185.382 40.1807H186.846L187.957 42.2982L189.041 40.1807H190.47L187.304 46.0869H185.876L187.26 43.5844Z",
  fill: "white"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M198.768 44.0833L199.711 38.2471H200.84L202.303 41.7383L203.767 38.2471H204.896L205.839 44.0833H204.481L204.014 40.6005L202.541 44.0833H202.065L200.592 40.6005L200.125 44.0833H198.768Z",
  fill: "white"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M211.738 38.2471V42.9455H213.563V44.0833H210.38V38.2471H211.738Z",
  fill: "white"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M219.595 38.2471V44.0833H218.237V38.2471H219.595Z",
  fill: "white"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M226.851 39.3846V44.0833H225.493V39.3846H224.214V38.2471H228.13V39.3846H226.851Z",
  fill: "white"
});

function SvgFooterLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 229,
    height: 50,
    viewBox: "0 0 229 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterLogo);
export default __webpack_public_path__ + "static/media/footer_logo.6d2cdd8a.svg";
export { ForwardRef as ReactComponent };